import { Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { PlayerBar } from './components/PlayerBar';
import { QueueDrawer } from './components/QueueDrawer';
import { TopBar } from './components/TopBar';
import { usePlayer } from './hooks/usePlayer';
import { useThemeBootstrap } from './hooks/useThemeBootstrap';
import { HomePage } from './pages/Home';
import { NowPlayingPage } from './pages/NowPlaying';
import { OfflinePage } from './pages/Offline';
import { PlaylistDetailPage } from './pages/PlaylistDetail';
import { PlaylistsPage } from './pages/Playlists';
import { SongsPage } from './pages/Songs';
import { UploadPage } from './pages/Upload';

function AppLayout() {
  const location = useLocation();
  const { isQueueOpen } = usePlayer();
  useThemeBootstrap();

  return (
    <div className="min-h-screen overflow-x-hidden bg-background bg-grain text-foreground">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col px-3 pb-24 pt-3 sm:px-6 sm:pb-32 sm:pt-4 lg:px-8">
        <TopBar currentPath={location.pathname} />
        <main className="mt-4 min-w-0 flex-1 sm:mt-6">
          <Outlet />
        </main>
      </div>
      <PlayerBar />
      <QueueDrawer open={isQueueOpen} />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<HomePage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/songs" element={<SongsPage />} />
        <Route path="/playlists" element={<PlaylistsPage />} />
        <Route path="/playlists/:playlistId" element={<PlaylistDetailPage />} />
        <Route path="/now-playing" element={<NowPlayingPage />} />
        <Route path="/offline" element={<OfflinePage />} />
      </Route>
    </Routes>
  );
}
